// Guards de ruta: RequireAuth y RequireRole.
import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuthStore, hasRole } from "../stores/auth";
import { getToken } from "../api/client";

export function RequireAuth({ children }: { children: JSX.Element }) {
  const { me, loading, loadMe } = useAuthStore();
  const location = useLocation();
  const token = getToken();

  useEffect(() => {
    if (token && !me && !loading) loadMe();
  }, [token, me, loading, loadMe]);

  if (!token) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!me) return <div className="p-8 text-tinta-3">Cargando sesión…</div>;

  // Contraseña generada por el admin y aún sin cambiar: el servidor responde 403
  // a todo lo demás, así que llevar aquí es lo único que tiene sentido hacer.
  // El corte de verdad lo hace el backend; esto solo evita una pantalla de errores.
  if (me.debe_cambiar_password && location.pathname !== "/cambiar-password") {
    return <Navigate to="/cambiar-password" replace />;
  }
  return children;
}

export function RequireRole({ roles, children }: { roles: string[]; children: JSX.Element }) {
  const me = useAuthStore((s) => s.me);
  return (
    <RequireAuth>
      {hasRole(me, ...roles) ? (
        children
      ) : (
        <div className="p-8 text-estado-serio">
          No tienes permiso para acceder a esta sección (requiere rol: {roles.join(", ")}).
        </div>
      )}
    </RequireAuth>
  );
}
